import {ReferencedRange} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshRange';
import {MeshUtils} from '@mintdata-wsp/common/util/MeshUtils';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {observer, inject} from 'mobx-react';
import * as React from 'react';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/Mesh.less');

interface IMeshReferencedRangesProps
{
    ctx?:IWSPMeshContext;
}

@inject('ctx')
@observer
export class MeshReferencedRanges extends React.Component<IMeshReferencedRangesProps>
{
    private _getRangeStyle(range:ReferencedRange):React.CSSProperties
    {
        const {ctx} = this.props;
        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);

        const rangeBounds = MeshUtils.getRangeBounds(range.from, range.to, meshState);
        if( rangeBounds )
        {
            const {x, y, width, height} = rangeBounds;
            return {
                transform: `translate(${x}px, ${y}px)`,
                width: `${width}px`,
                height: `${height}px`,
                border: `2px dashed ${range.color}`
            };
        }

        return {};
    }

    public render():JSX.Element
    {
        const {isEditMode, editSheetId} = controllers.ui.spreadsheets.main.getEditorState();
        const {referencedRanges} = controllers.ui.spreadsheets.main.getEditorState().input;

        const activeSheet = controllers.ui.spreadsheets.main.getActiveSheet();

        let sheetName = activeSheet.name.replace(/'/g, '\'\'');
            
        if( sheetName.includes(' ') || sheetName.includes('\'\'') )
            sheetName = `'${sheetName}'`;

        return isEditMode && referencedRanges && <div>
            {
                Array.from(referencedRanges.values())
                    .filter(range => range.sheetName ? range.sheetName === sheetName : activeSheet.id === editSheetId)
                    .map((range:ReferencedRange, index:number) =>
                    {  
                        return <div
                            key={index}
                            style={this._getRangeStyle(range)}
                            className={styles.referencedRange}
                        />
                    })
            }
        </div>;
    }
}
